/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, {useState} from 'react';
import { IAbsoluteModalWindowViewProps } from './absolute-modal-window';

import { Modal, ModalHeader, ModalBody } from 'reactstrap';

export default (props: IAbsoluteModalWindowViewProps) => {

    

    const { 
        modalTitle, 
        modalContent, 
        modalImage,
        //@ts-ignore
        buttonLabel, className,
        links
        
    } = props;

    const [modal, setModal] = useState(true);

    const toggle = () => setModal(!modal);


    return (

    <div>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
        <ModalBody className="flex-md">
            <div className="forty">{modalImage}</div>
            <div className="sixty flex-vertical padding-10">
                {modalContent}
                {links}
            </div>
         </ModalBody>
      </Modal>
    </div>


       
    );
};
